import { z } from 'zod';

import { InputText, type InputTextProps } from '@/components/controls';

export type FormInputTextProps = InputTextProps;

export const FormInputText = ({ ...props }: FormInputTextProps) => {
  return <InputText {...props} />;
};

FormInputText.displayName = 'Forms.InputText';

export const required = (message = 'The field is required', min = 1) => {
  return z.string({ message }).min(min, { message });
};

FormInputText.rules = { required };
